(() => {
  const openOrders = document.querySelector(".js-my-orders-menu");
  const closeOrders = document.querySelector(".js-close-order-menu");

  // const openAddresses = document.querySelector(".js-addresses-menu");
  // const closeAddresses = document.querySelector(".js-close-addresses-menu");

  const openPassword = document.querySelector(".js-open-password");
  const closePassword = document.querySelector(".js-close-password-menu");

  const ordersWrapper = document.querySelector(".js-orders-card");
  const addressesWrapper = document.querySelector(".js-addresses-card");
  const passwordWrapper = document.querySelector(".js-change-password-card");

  openPassword.addEventListener("click", (e) => {
    passwordWrapper.classList.remove("menu-translate-outside");
    setTimeout(() => {
      document.body.classList.add("remove-scrolling");
    }, "350");
  });

  closePassword.addEventListener("click", () => {
    passwordWrapper.classList.add("menu-translate-outside");
    document.body.classList.remove("remove-scrolling");
  });

  openOrders.addEventListener("click", (e) => {
    ordersWrapper.classList.remove("menu-translate-outside");
    setTimeout(() => {
      document.body.classList.add("remove-scrolling");
    }, "350");
  });

  closeOrders.addEventListener("click", () => {
    ordersWrapper.classList.add("menu-translate-outside");
    document.body.classList.remove("remove-scrolling");
  });

  // openAddresses.addEventListener("click", (e) => {
  //   addressesWrapper.classList.remove("menu-translate-outside");
  // });

  // closeAddresses.addEventListener("click", () => {
  //   addressesWrapper.classList.add("menu-translate-outside");
  // });

  const openDetails = Array.from(document.querySelectorAll(".js-open-order-details"));
  const detailsWrapper = Array.from(document.querySelectorAll(".js-order-detail-menu"));
  const closeDetails = Array.from(document.querySelectorAll(".js-order-detail-menu"));

  openDetails.forEach(function (menu, i) {
    menu.addEventListener("click", () => {
      detailsWrapper[i].classList.remove("menu-translate-outside");
    });
  });

  closeDetails.forEach(function (menu, i) {
    menu.addEventListener("click", () => {
      detailsWrapper[i].classList.add("menu-translate-outside");
    });
  });
})();

document.addEventListener('DOMContentLoaded', () => {
  const sortButtonMobile = document.querySelector('.sort-dropdown-mobile__button');
  const sortMenuMobile = document.querySelector('.sort-dropdown-mobile__menu');
  const sortLinksMobile = document.querySelectorAll('.sort-dropdown-mobile__link');
  const ordersContainerMobile = document.querySelector('.menu-body');
  sortButtonMobile.addEventListener('click', (e) => {
    e.stopImmediatePropagation();
    sortMenuMobile.classList.toggle('active');
  });
  sortLinksMobile.forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const sortOrder = link.getAttribute('data-sort');
      sortLinksMobile.forEach(link => link.classList.remove('active'));
      link.classList.add('active');
      const ordersWithDate = [];
      const ordersWithoutDate = [];
      Array.from(ordersContainerMobile.querySelectorAll('.menu-content__item')).forEach(item => {
        if (item.hasAttribute('data-date')) {
          ordersWithDate.push(item);
        } else {
          ordersWithoutDate.push(item);
        }
      });
      ordersWithDate.sort((a, b) => {
        const dateA = new Date(a.getAttribute('data-date'));
        const dateB = new Date(b.getAttribute('data-date'));
        return sortOrder === 'newest' ? dateB - dateA : dateA - dateB;
      });
      ordersWithDate.forEach(order => ordersContainerMobile.appendChild(order));
      ordersWithoutDate.forEach(order => ordersContainerMobile.appendChild(order));
      sortMenuMobile.classList.remove('active');
    });
  });
});